module.exports = function(done, value){
  return {value: value, done: !!done};
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/$.iter-step.js
 ** module id = 425
 ** module chunks = 0 1 4 5 6 7 8
 **/